import React from 'react';
import Head from 'next/head';

const title = ({ value }: { value: string }) => {
    return (
        <Head>
            <title>{value}</title>
        </Head>
    );
};

export default title;
